import { Injectable } from '@angular/core';
import { Data } from '@angular/router';


interface DeviceInfo {
  batteryHealth: string;
  browserVersion: string;
  connectionType: string;
  deviceMemory: number;
  hardwareConcurrency: number;
  osVersion: string;
  userAgent: string;
}

interface Parts {
  stringPart: string;
  numericalPart: string;
  OSNum: string;
  osName: string;
}

@Injectable({
  providedIn: 'root'
})
export class DevicePerformanceService {

    constructor() {}
    public sessionStorageKey: string;

   highPerformance(highPerformData: Data, sessionInfo: DeviceInfo, parts: Parts) {
    const highPerformanceData = highPerformData;
    const sessionData = sessionInfo;
    const sPart = parts.stringPart;
    const nPart = parts.numericalPart;
    const osNumber = parts.OSNum;
    let performance_group_number = 0;
    let reason = "Default";
    const versionState = this.checkBrowserVersion(sPart, nPart);
    const osVersion = this.checkOsVersion(osNumber);
    if (sessionData?.deviceMemory >= highPerformanceData?.device_memory) {
      if (
        sessionData.connectionType == highPerformanceData?.connection_type[0] ||
        sessionData.connectionType == highPerformanceData?.connection_type[1]
      ) {
        if (sessionData.batteryHealth == highPerformanceData.battery_health) {
          if (sessionData.hardwareConcurrency >= highPerformanceData.hardware_concurrency) {
            if (versionState == highPerformanceData.browser_version) {
              if (parts.osName == "Android") {
                if (osVersion >= highPerformanceData.os_version.android) {
                  performance_group_number = highPerformanceData.performance_group;
                } else {
                  reason = "Required OSVersion " + parts.osName + " " + highPerformanceData.os_version.android;
                }
              } else if (parts.osName == "ios") {
                if (osVersion >= highPerformanceData.os_version.ios) {
                  performance_group_number = highPerformanceData.performance_group;
                } else {
                  reason = "Required OSVersion " + parts.osName + " " + highPerformanceData.os_version.ios;
                }
              } else {
                reason = "Not matching OSVersion";
              }
            } else {
              reason = "Not " + versionState + " Browser Version";
            }
          } else {
            reason = "Low Concurrancy. Required Concurrency " + highPerformanceData.hardware_concurrency;
          }
        } else {
          reason = "Weak Battery Level";
        }
      } else {
        reason =
          "Required Connection " +
          highPerformanceData.connection_type[0] +
          " or " +
          highPerformanceData.connection_type[1];
      }
    } else {
      reason = "Low Memory. Required Memory " + highPerformanceData?.device_memory;
    }
    const data = {
      Reason: reason,
      PerformanceGroupNumber: performance_group_number,
    };
    return data;
  }

  checkBrowserVersion(browserName: string, browserVersion: string): string {
    const bVersion = parseInt(browserVersion);

    if (browserName === "Chrome") {
      return this.checkChromeVersion(bVersion);
    } else if (browserName === "Safari") {
      return this.checkSafariVersion(browserVersion);
    } else {
      return "Unsupported";
    }
  }


  checkChromeVersion(bVersion: number): string {
    if (bVersion >= 115) {
      return "Latest";
    } else if (bVersion >= 110) {
      return "Recent";
    } else if (bVersion >= 100) {
      return "Older";
    } else {
      return "Very Old";
    }
  }

  checkSafariVersion(browserVersion: string): string {
    const numStr = browserVersion.toString();
    const match = numStr.match(/^(\d+)/);
    const firstDigit = match[1];
    const numDigits = parseInt(firstDigit);

    if (numDigits >= 14) {
      return "Latest";
    } else if (numDigits >= 12) {
      return "Recent";
    } else if (numDigits >= 10) {
      return "Older";
    } else {
      return "Very Old";
    }
  }

    checkOsVersion(osNumber: string) {
    if (osNumber && osNumber !== "") {
      const numStr = osNumber.toString();
      const match = numStr.match(/^(\d+)/);
      const firstDigit = match[1];
      const numDigits = parseInt(firstDigit);

      return numDigits;
    }
  }


    mediumPerformance(highPerformData: Data, mediumPerformData: Data, sessionInfo: DeviceInfo, parts: Parts) {
    const mediumPerformanceData = mediumPerformData;
    const sessionData = sessionInfo;
    const sPart = parts.stringPart;
    const nPart = parts.numericalPart;
    const osNumber = parts.OSNum;
    let performance_group_number = 0;
    let reason = "Default";
    const versionState = this.checkBrowserVersion(sPart, nPart);
    const osVersion = this.checkOsVersion(osNumber);
    if (sessionData?.deviceMemory > mediumPerformanceData?.device_memory) {
      if (
        sessionData.connectionType == mediumPerformanceData.connection_type ||
        sessionData.connectionType == highPerformData.connection_type[0] ||
        sessionData.connectionType == highPerformData.connection_type[1]
      ) {
        if (
          sessionData.batteryHealth == mediumPerformanceData.battery_health ||
          sessionData.batteryHealth == highPerformData.battery_health
        ) {
          if (sessionData.hardwareConcurrency > mediumPerformanceData.hardware_concurrency) {
            if (
              versionState == mediumPerformanceData.browser_version ||
              versionState == highPerformData.browser_version
            ) {
              if (parts.osName == "Android") {
                if (osVersion >= mediumPerformanceData.os_version.android) {
                  performance_group_number = mediumPerformanceData.performance_group;
                } else {
                  reason = "Required OSVersion " + parts.osName + " " + mediumPerformanceData.os_version.android;
                }
              } else if (parts.osName == "ios") {
                if (osVersion >= mediumPerformanceData.os_version.ios) {
                  performance_group_number = mediumPerformanceData.performance_group;
                } else {
                  reason = "Required OSVersion " + parts.osName + " " + mediumPerformanceData.os_version.ios;
                }
              } else {
                reason = "Not matching OSVersion";
              }
            } else {
              reason = "Not " + versionState + " Browser Version";
            }
          } else {
            reason = "Low Concurrancy. Required " + mediumPerformanceData.hardware_concurrency;
          }
        } else {
          reason = "Weak Battery Level";
        }
      } else {
        reason = "Weak Connection. Required " + mediumPerformanceData.connection_type;
      }
    } else {
      reason = "Low Memory. Required " + mediumPerformanceData?.device_memory;
    }
    const data = {
      Reason: reason,
      PerformanceGroupNumber: performance_group_number,
    };
    return data;
    }

    lowPerformance(
    highPerformData: Data,
    mediumPerformData: Data,
    lowPerformData: Data,
    sessionInfo: DeviceInfo,
    parts: Parts
  ) {
    const lowPerformanceData = lowPerformData;
    const sessionData = sessionInfo;
    let performance_group_number = 0;
    let reason = "Default";
    const versionState = this.checkBrowserVersion(parts.stringPart, parts.numericalPart);
    const osVersion = this.checkOsVersion(parts.OSNum);
    if (sessionData?.deviceMemory >= lowPerformanceData?.device_memory) {
      if (
        sessionData.connectionType == lowPerformanceData.connection_type ||
        sessionData.connectionType == mediumPerformData.connection_type ||
        sessionData.connectionType == highPerformData.connection_type[0] ||
        sessionData.connectionType == highPerformData.connection_type[1]
      ) {
        if (
          sessionData.batteryHealth == lowPerformanceData.battery_health ||
          sessionData.batteryHealth == mediumPerformData.battery_health ||
          sessionData.batteryHealth == highPerformData.battery_health
        ) {
          if (sessionData.hardwareConcurrency >= lowPerformanceData.hardware_concurrency) {
            if (
              versionState == lowPerformanceData.browser_version ||
              versionState == mediumPerformData.browser_version ||
              versionState == highPerformData.browser_version
            ) {
              if (parts.osName == "Android") {
                if (osVersion >= lowPerformanceData.os_version.android) {
                  performance_group_number = lowPerformanceData.performance_group;
                } else {
                  reason = "Required OSVersion " + parts.osName + " " + lowPerformanceData.os_version.android;
                }
              } else if (parts.osName == "ios") {
                if (osVersion >= lowPerformanceData.os_version.ios) {
                  performance_group_number = lowPerformanceData.performance_group;
                } else {
                  reason = "Required OSVersion " + parts.osName + " " + lowPerformanceData.os_version.ios;
                }
              } else {
                reason = "Not matching OSVersion";
              }
            } else {
              reason = versionState + " Browser Version";
            }
          } else {
            reason = "Low Concurrancy. Required " + lowPerformanceData.hardware_concurrency;
          }
        } else {
          reason = "Weak Battery Level";
        }
      } else {
        reason = "Weak Connection. Required " + lowPerformanceData.connection_type;
      }
    } else {
      reason = "Low Memory. Required " + lowPerformanceData?.device_memory;
    }
    const data = {
      Reason: reason,
      PerformanceGroupNumber: performance_group_number,
    };
    return data;
    }


    veryLowPerformance(
        highPerformData: Data,
        mediumPerformData: Data,
        lowPerformData: Data,
        veryLowPerformData,
        sessionInfo: DeviceInfo,
        parts: Parts
      ) {
        const veryLowPerformanceData = veryLowPerformData;
        const sessionData = sessionInfo;
        let performance_group_number = 0;
        let reason = "Default";
        const versionState = this.checkBrowserVersion(parts.stringPart, parts.numericalPart);
        const osVersion = this.checkOsVersion(parts.OSNum);
        if (sessionData?.deviceMemory >= veryLowPerformanceData?.device_memory) {
          if (
            sessionData.connectionType == veryLowPerformanceData.connection_type ||
            sessionData.connectionType == lowPerformData.connection_type ||
            sessionData.connectionType == mediumPerformData.connection_type ||
            sessionData.connectionType == highPerformData.connection_type[0] ||
            sessionData.connectionType == highPerformData.connection_type[1]
          ) {
            if (
              sessionData.batteryHealth == veryLowPerformanceData.battery_health ||
              sessionData.batteryHealth == lowPerformData.battery_health ||
              sessionData.batteryHealth == mediumPerformData.battery_health ||
              sessionData.batteryHealth == highPerformData.battery_health
            ) {
              if (sessionData.hardwareConcurrency >= veryLowPerformanceData.hardware_concurrency) {
                if (
                  versionState == veryLowPerformanceData.browser_version ||
                  versionState == highPerformData.browser_version ||
                  versionState == mediumPerformData.browser_version ||
                  versionState == lowPerformData.browser_version
                ) {
                  if (parts.osName == "Android") {
                    if (osVersion >= veryLowPerformanceData.os_version.android) {
                      performance_group_number = veryLowPerformanceData.performance_group;
                    } else {
                      reason = "Required OSVersion " + parts.osName + " " + veryLowPerformanceData.os_version.android;
                    }
                  } else if (parts.osName == "ios") {
                    if (osVersion >= veryLowPerformanceData.os_version.ios) {
                      performance_group_number = veryLowPerformanceData.performance_group;
                    } else {
                      reason = "Required OSVersion " + parts.osName + " " + veryLowPerformanceData.os_version.ios;
                    }
                  } else {
                    reason = "Not matching OSVersion";
                  }
                } else {
                  reason = versionState + " Browser Version";
                }
              } else {
                reason = "Low Concurrancy. Required " + veryLowPerformanceData.hardware_concurrency;
              }
            } else {
              reason = "Weak Battery Level";
            }
          } else {
            reason = "Weak Connection. Required " + veryLowPerformanceData.connection_type;
          }
        } else {
          reason = "Low Memory. Required " + veryLowPerformanceData?.device_memory;
        }
        const data = {
          Reason: reason,
          PerformanceGroupNumber: performance_group_number,
        };
        return data;
    }

    getSessionData() {
        const sessionData = sessionStorage.getItem(this.sessionStorageKey);
        return sessionData ? JSON.parse(sessionData) : null;
    }

}